import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import InvoiceUnreceivedTable from './InvoiceUnreceivedTable';


const InvoiceUnreceivedAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM Do, YYYY')}
    icon={<BarnyardIcon icon={['fa', 'file-invoice-dollar']} className='DiscussCard__replyIcon' />}
    title={(
      <div>
        <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
          {alert.buyer.name}
        </Link>
        {' '} has an unreceived invoice from more than {' '}
        <strong>
          {alert.value.number_days}
        </strong>
        {' '} days ago {' '}
      </div>
    )}
    content={(
      <InvoiceUnreceivedTable
        includeExport={true}
        invoices={alert.value.invoices}
      />
    )}
    {...other}
  />
);

InvoiceUnreceivedAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default InvoiceUnreceivedAlert;
